// extracted by mini-css-extract-plugin
export default {"wrapperModal":"styles_wrapperModal__f1tZc","wrapperForm":"styles_wrapperForm__UIvV2","itemInput":"styles_itemInput__3iWAA","wrapperButton":"styles_wrapperButton__XXo2k"};